import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, afterNextRender, computed, inject, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SharedModule } from '@shared/shared.module';
import { CommentsModalComponent } from '../../components/comments-modal/comments-modal.component';
import { WebEngageRepository } from '@core/services/repositories/webEngage.repository';
import { ModalService } from '@shared/services/modal.service';
import { SearchBoxService } from '@shared/services/serach-box.service';

@Component({
 selector: 'iho-comments',
 standalone: true,
 imports: [CommonModule, SharedModule],
 templateUrl: './comments.component.html',
 styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit {
 constructor() {
  afterNextRender(() => {
   this.resetSwiper.set(false);
   setTimeout(() => this.resetSwiper.set(true), 0);
  });
 }

 configSwiperComments: any;
 dialog = inject(MatDialog);
 swiperService = inject(SwiperService);

 @Input() dataSourceLabelHotelReview: any;
 @Input() dataVotes?: any[];
 @Input() hotelId?: number;
 @Input() HotelHeader?: any;
 @Input() type?: number;
 @Input() houseId?: string;

 resetSwiper = signal(true);
 private searchBoxService = inject(SearchBoxService);
 accommodation = computed(() => this.searchBoxService.accommodation());
 webEngageRepo = inject(WebEngageRepository);
 modalService = inject(ModalService);

 ngOnInit(): void {
  let config = {
   slide: 'auto',
   pagination: {
    enabled: false,
    clickable: false,
   },
  };
  this.configSwiperComments = this.swiperService.SwiperConfig(config);
 }

 showModalComments() {
  const dialogRef = this.dialog.open(CommentsModalComponent, {
   panelClass: [
    'custom-modal',
    'comments-modal',
    'w-screen',
    'lg:w-[80%]',
    'h-screen',
    '!max-w-full',
    'lg:h-[88vh]',
    'lg:min-h-[700px]',
   ],
   data: {
    dataSource: this.dataSourceLabelHotelReview,
    HotelHeader: this.HotelHeader,
    hid: this.hotelId,
    type: this.type,
    HouseId: this.houseId,
   },
   autoFocus: false,
  });
  // Handle the result or any other actions as needed
  dialogRef.afterClosed().subscribe((result) => {
   this.modalService.isAnyModalOpen.set(false);
  });

  dialogRef.afterOpened().subscribe(() => {
   this.modalService.isAnyModalOpen.set(true);
  });
 }
}
